import { useTheme } from '@vebox/etui-system';
import { createElement } from 'react';
import '../_rollupPluginBabelHelpers-3b7bd988.js';
import 'json2mq';
import './MediaQueryList.js';
import Media from './Media.js';

const render = element => () => element;
const ShowOnSmallDevice = props => {
  const theme = useTheme();
  return /*#__PURE__*/createElement(Media, {
    targetWindow: props.targetWindow,
    query: {
      maxWidth: parseInt(theme.breakpoints[1], 10)
    },
    render: render(props.children)
  });
};
const HideOnSmallDevice = props => {
  const theme = useTheme();
  return /*#__PURE__*/createElement(Media, {
    targetWindow: props.targetWindow,
    query: {
      minWidth: parseInt(theme.breakpoints[1], 10) + 1
    },
    render: render(props.children)
  });
};
const ShowOnMaxWidth = props => /*#__PURE__*/createElement(Media, {
  targetWindow: props.targetWindow,
  query: {
    maxWidth: props.maxWidth
  },
  render: render(props.children)
});
const HideOnMinWidth = props => /*#__PURE__*/createElement(Media, {
  targetWindow: props.targetWindow,
  query: {
    minWidth: +props.minWidth + 1
  },
  render: render(props.children)
});

export { HideOnMinWidth, HideOnSmallDevice, ShowOnMaxWidth, ShowOnSmallDevice };
